// Prevent default when clicking a disabled link.
real.dom.$body.on('click', '.real-link.disabled', function (e) {
    e.stopImmediatePropagation();
    return false;
});

/**
 * Without the download attribute Firefox would close the websocket
 * connection when user clicks the link. Only do this trick for
 * Firefox as adding the download attribute can lead to bad
 * UX on other browsers ("download files prompt" can appear on Chrome).
 *
 * https://bugzilla.mozilla.org/show_bug.cgi?id=858538
 * https://bugzilla.mozilla.org/show_bug.cgi?id=896666
 */
if (real.browser.isFirefox) {
    real.dom.$body.on('click', '.real-link', function () {
        const link = $(this);
        if (link.data('link-type') === 'download' && link[0].hasAttribute('download') === false) {
            link.attr('download', '');
        }
    });
}
